/* RESPONSIBLE TEAM: team-messenger */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    caseFields: {
      serialize: false,
      deserialize: 'records',
    },
    requiredCaseFields: {
      serialize: false,
      deserialize: 'records',
    },
  },
});
